import React from "react";
import {
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  Divider,
  Card,
  CardContent,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Shield } from "@mui/icons-material";
import ContactInfoXs from "./ContactInfoXs"; // Adjust the import path as necessary

const PersonalInfoPolicyXs = ({ id }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        p: 2,
        backgroundColor: "#f5f5f7",
        minHeight: "100vh",
        maxWidth: "100%",
        overflow: "hidden",
      }}
      id={id}
    >
      {/* iOS-style header */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          mb: 2,
          pb: 1,
          borderBottom: "1px solid rgba(0,0,0,0.1)",
        }}
      >
        <Typography
          variant="subtitle1"
          component="h1"
          fontWeight="600"
          sx={{ textAlign: "center" }}
        >
          {t("privacy-policy.personal-info-policy.title")}
        </Typography>
      </Box>

      {/* Main content in iOS-style cards */}
      <Card
        elevation={0}
        sx={{
          mb: 2,
          borderRadius: 2,
          backgroundColor: "white",
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        }}
      >
        <CardContent sx={{ px: 2, py: 1.5, "&:last-child": { pb: 1.5 } }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
            <Shield sx={{ color: "#007AFF", mr: 1.5 }} />
            <Typography variant="subtitle1" fontWeight="500">
              {t("privacy-policy.personal-info-policy.intro")}
            </Typography>
          </Box>
        </CardContent>
      </Card>

      {/* Policy items in iOS-style list */}
      <Card
        elevation={0}
        sx={{
          mb: 2,
          borderRadius: 2,
          backgroundColor: "white",
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          overflow: "hidden",
        }}
      >
        <List disablePadding>
          {t("privacy-policy.personal-info-policy.items", {
            returnObjects: true,
          }).map((item, index, array) => (
            <React.Fragment key={index}>
              <ListItem
                sx={{
                  px: 2,
                  py: 1.5,
                }}
              >
                <ListItemText
                  primary={item}
                  primaryTypographyProps={{
                    variant: "body2",
                    sx: { color: "#333" },
                  }}
                />
              </ListItem>
              {index < array.length - 1 && (
                <Divider variant="inset" component="li" sx={{ ml: 2 }} />
              )}
            </React.Fragment>
          ))}
        </List>
      </Card>

      {/* Footer information */}
      <Card
        elevation={0}
        sx={{
          mb: 2,
          borderRadius: 2,
          backgroundColor: "white",
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        }}
      >
        <CardContent sx={{ px: 2, py: 1.5, "&:last-child": { pb: 1.5 } }}>
          <Typography variant="caption" sx={{ display: "block", mb: 0.5 }}>
            {t("privacy-policy.personal-info-policy.footer.company")}
          </Typography>
          <Typography variant="caption" sx={{ display: "block" }}>
            {t("privacy-policy.personal-info-policy.footer.dates")}
          </Typography>
        </CardContent>
      </Card>

      {/* Contact info */}
      <Card
        elevation={0}
        sx={{
          borderRadius: 2,
          backgroundColor: "white",
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        }}
      >
        <CardContent sx={{ px: 2, py: 1.5, "&:last-child": { pb: 1.5 } }}>
          <Typography variant="body2" sx={{ mb: 1.5 }}>
            {t("privacy-policy.personal-info-policy.contact")}
          </Typography>
          <Box sx={{ mt: 1 }}>
            <ContactInfoXs />
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default PersonalInfoPolicyXs;
